/* eslint-disable */
import React, { useContext } from 'react'
import { Outlet } from 'react-router-dom'
import { SiteProvider } from 'providers/site'
import MonitoringProvider from 'providers/monitoring'

import SiteMonitoringHeader from 'flow/SiteMonitoring/components/Header'
import SiteMonitoringFooter from 'flow/SiteMonitoring/components/Footer'
import { IsFullScreenContext } from 'routing'

const SiteMonitoringFlow = () => {
  const isFullScreen = useContext(IsFullScreenContext)

  return (
    <>
      <SiteProvider>
        <MonitoringProvider>
          <SiteMonitoringHeader />
          <div>
            <Outlet />
          </div>
          <div style={{ marginTop: isFullScreen ? 0 : '168px' }}>
            <SiteMonitoringFooter />
          </div>
        </MonitoringProvider>
      </SiteProvider>
    </>
  )
}

export default SiteMonitoringFlow
